module.exports = __webpack_public_path__ + "static/media/icon-fullscreen-expand.76517758.svg";